import { Paragraph, TextRun, TabStopType } from "docx";

const ModelWordTextDotValue = (jsonData) => {
  const sections = [];

  const categoryTitles = {
    TV: "Televizionet",
    RADIO: "Radiot",
    CABLE: "Kabllore",
    OTHER: "Shërbime të tjera",
  };

  const orderedCategories = ["TV", "RADIO", "CABLE", "OTHER"];

  orderedCategories.forEach((category) => {
    const entries = jsonData[category];
    if (!entries || entries.length === 0) return;

    // Titulli i seksionit
    sections.push(
      new Paragraph({
        children: [
          new TextRun({
            text: categoryTitles[category] || category,
            color: "e60000",
            size: 24,
          }),
        ],
        spacing: { after: 200 },
      })
    );

    entries.forEach((entry) => {
      const { Oshma, ...otherFields } = entry;

      Object.entries(otherFields).forEach(([label, value]) => {
        const amount =
          typeof value === "number"
            ? value.toLocaleString("sq-AL")
            : `${value ?? ""}`;

        const leftText = `Shoqëria “${Oshma}” sh.a.`;

        sections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: `${leftText}\t${amount}`,
                font: "Arial",
                size: 24,
              }),
            ],
            spacing: {
              before: 100,
              after: 100,
            },
            tabStops: [
              {
                type: TabStopType.RIGHT,
                position: 9000, // pozicion sipas kolonës së djathtë
                leader: "dot", // ose "dots"
              },
            ],
          })
        );
      });
    });

    sections.push(new Paragraph({ text: "", spacing: { after: 300 } }));
  });

  return sections;
};

export default ModelWordTextDotValue;
